import { ModalHandler } from '@app-velocity/ui';

import { SnapshotWarningsModalContent } from './components/SnapshotWarningsModalContent';

export const SnapshotWarningsModal = () => {
  return (
    <ModalHandler channel="prototypes" id="snapshot-warnings">
      <SnapshotWarningsModalContent />
    </ModalHandler>
  );
};
